export default __webpack_public_path__ + "static/media/logo-mark.54575923.svg";